function meshTransferables(mesh) {
    return [
        mesh.points,
        mesh.pointData,
        mesh.cells,
        mesh.cellData
    ];
}
export default meshTransferables;
//# sourceMappingURL=mesh-transferables.js.map